import { buildEventScores } from '@moment-golf/shared';
import type { tbEvent, ViewEventData } from '@moment-golf/types';

interface CreateEventScoresProps {
    auth: { user?: { profile?: { sub?: string } } };
    viewEvent: tbEvent;
    viewEventData: ViewEventData;
}

export const CreateEventScores = (props: CreateEventScoresProps) => buildEventScores(props);
